// src/hooks/useUserRole.js
// Sprint 1 P0 — exposes role do usuário autenticado para gates de UI (E1.4 sensitive, E1.5 antilist).
// Lê primeiro user_metadata.role (gravado via Supabase Dashboard) e cai para app_metadata.role.
//
// Roles esperadas (ver migrations P0 v2.1):
//   - founder       → eduardo@astoncapital.com.br (pode acionar enrich sensível, criar antilistas globais)
//   - collaborator  → fabio@spareas.com.br, caroline@astoncapital.com.br
//   - viewer        → futuro
//
// admin é tratado como sinônimo de founder em algumas políticas RLS — mantemos compat.

import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

export function useUserRole() {
  const [role, setRole] = useState('collaborator');
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const apply = (user) => {
      if (!mounted) return;
      const r =
        user?.user_metadata?.role ||
        user?.app_metadata?.role ||
        'collaborator';
      setRole(r);
      setEmail(user?.email || null);
    };

    supabase.auth.getUser().then(({ data }) => {
      apply(data?.user);
      if (mounted) setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      apply(session?.user);
    });

    return () => { mounted = false; subscription.unsubscribe(); };
  }, []);

  return { role, loading, email };
}

// founder OR admin (alias usado em algumas políticas)
export function useIsFounder() {
  const { role } = useUserRole();
  return role === 'founder' || role === 'admin';
}
